import * as React from "react"

import { cn } from "../../lib/utils"
import { Eye } from "lucide-react"

  export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    startEnhancer?: React.ReactNode
    endEnhancer?: React.ReactNode
  } 

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ startEnhancer, endEnhancer, className, type, ...props }, ref) => {
    const [type_state, settype_state] = React.useState(type);

    //"flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"

    return (
    <div className={`${cn("relative border border-input rounded-md bg-background ring-offset-background [&:has(input:focus)]:outline-none [&:has(input:focus)]:ring-2 [&:has(input:focus)]:ring-ring [&:has(input:focus)]:ring-offset-2", className)}`}>
        {startEnhancer && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            {startEnhancer}
          </div>
        )}
        <input
          type={type_state}
          className={cn(
            "flex h-10 w-full rounded-md bg-transparent px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
            startEnhancer ? "pl-9" : "", // Add left padding if startEnhancer exists
          )}
          ref={ref}
          {...props}
        />
        {type==='password' && (
          <button onMouseDown={()=>{settype_state('text')}} onMouseUp={()=>{settype_state('password')}} onTouchStart={()=>{settype_state('text')}} onTouchEnd={()=>{settype_state('password')}} className="absolute inset-y-0 right-2 opacity-50">
            <Eye className="w-4"/>
          </button>
        )}

        {endEnhancer && (
          <div className="absolute inset-y-0 right-2 flex items-center">
            {endEnhancer}
          </div>
        )}

    </div>
    )
  }
)
Input.displayName = "Input"

export { Input }